
<j-process-node-group
    ref="root"
    :source="node"
    :configs="configs"
    v-on="$listeners">
    <j-icon :configs="imageConfig"></j-icon>
</j-process-node-group>
